import Urls from "../../constants/urls";
import mac from "./imgs/mac.jpg";
import piano from "./imgs/piano.jpg";
import recording from "./imgs/recording.jpg";
import shelves from "./imgs/shelves.jpg";
import tshirt from "./imgs/tshirt.jpg";
import keyboard from "./imgs/keyboard.jpg";

export const macHotspots = [
    {
        type: "spot",
        xPosition: 19,
        yPosition: -30,
        zPosition: 80,
        xRotation: 35,
        yRotation: -170,
        zRotation: 80,
        radius: 5,
        link: Urls.musicStudio.shelves.path,
    },
    {
        type: "spot",
        xPosition: 52,
        yPosition: -30,
        zPosition: 55,
        xRotation: 35,
        yRotation: -140,
        zRotation: 90,
        radius: 5,
        link: Urls.musicStudio.piano.path,
    },
    {
        type: "spot",
        xPosition: 75,
        yPosition: -30,
        zPosition: 15,
        xRotation: 35,
        yRotation: -100,
        zRotation: 101,
        radius: 5,
        link: Urls.musicStudio.tshirt.path,
    },
    {
        type: "spot",
        xPosition: 0,
        yPosition: -30,
        zPosition: -40,
        xRotation: 10,
        yRotation: -5,
        zRotation: 0,
        radius: 4,
        link: Urls.musicStudio.keyboard.path,
    },
    {
        type: "arrow",
        xPosition: -29,
        yPosition: -30,
        zPosition: 73,
        xRotation: 40,
        yRotation: -205,
        zRotation: 20,
        radius: 5,
        link: Urls.musicStudio.recording.path,
    },

];

export const pianoHotspots = [
    {
        type: "arrow",
        xPosition: -2,
        yPosition: -25,
        zPosition: -80,
        xRotation: -90,
        yRotation: -90,
        zRotation: 180,
        radius: 6,
        link: Urls.musicStudio.recording.path,
    },
    {
        type: "spot",
        xPosition: 45,
        yPosition: -25,
        zPosition: -45,
        xRotation: -90,
        yRotation: -90,
        zRotation: 60,
        radius: 6,
        link: Urls.musicStudio.mac.path,
    },
    {
        type: "spot",
        xPosition: 85,
        yPosition: -25,
        zPosition: -42,
        xRotation: -85,
        yRotation: -95,
        zRotation: 37,
        radius: 6,
        link: Urls.musicStudio.keyboard.path,
    },
    {
        type: "spot",
        xPosition: 41,
        yPosition: -25,
        zPosition: 9,
        xRotation: -90,
        yRotation: -90,
        zRotation: 315,
        radius: 4,
        link: Urls.musicStudio.tshirt.path,
    },
    {
        type: "spot",
        xPosition: -10,
        yPosition: -25,
        zPosition: -35,
        xRotation: -90,
        yRotation: -90,
        zRotation: 145,
        radius: 4,
        link: Urls.musicStudio.shelves.path,
    },
];

export const keyboardHotspots = [

    {
        type: "spot",
        xPosition: 60,
        yPosition: -25,
        zPosition: -75,
        xRotation: -90,
        yRotation: -85,
        zRotation: 70,
        radius: 6,
        link: Urls.musicStudio.tshirt.path,
    },
    {
        type: "spot",
        xPosition: 110,
        yPosition: -25,
        zPosition: -60,
        xRotation: -85,
        yRotation: -95,
        zRotation: 30,
        radius: 6,
        link: Urls.musicStudio.piano.path,
    },
    {
        type: "spot",
        xPosition: 110,
        yPosition: -25,
        zPosition: -20,
        xRotation: -85,
        yRotation: -95,
        zRotation: 360,
        radius: 6,
        link: Urls.musicStudio.shelves.path,
    },
    {
        type: "spot",
        xPosition: 40,
        yPosition: -25,
        zPosition: 5,
        xRotation: -90,
        yRotation: -90,
        zRotation: 330,
        radius: 4,
        link: Urls.musicStudio.mac.path,
    },

];

export const recordingHotspots = [
    {
        type: "arrow",
        yPosition: -50,
        zPosition: 75,
        xPosition: 15,
        xRotation: 280,
        yRotation: 180,
        zRotation: 180,
        radius: 5,
        link: Urls.musicStudio.mac.path,
    }
];

export const shelvesHotspots = [
    {
        type: "spot",
        yPosition: -55,
        zPosition: -55,
        xPosition: -15,
        xRotation: 270,
        yRotation: 0,
        zRotation: -360,
        radius: 5,
        link: Urls.musicStudio.piano.path,
    },
    {
        type: "spot",
        yPosition: -55,
        zPosition: -99,
        xPosition: -105,
        xRotation: 273,
        yRotation: 10,
        zRotation: 20,
        radius: 9,
        link: Urls.musicStudio.tshirt.path,
    },
    {
        type: "spot",
        yPosition: -50,
        zPosition: 35,
        xPosition: -105,
        xRotation: 270,
        yRotation: 10,
        zRotation: 110,
        radius: 9,
        link: Urls.musicStudio.mac.path,
    },
    {
        type: "spot",
        yPosition: -55,
        zPosition: 10,
        xPosition: -210,
        xRotation: 260,
        yRotation: -90,
        zRotation: 200,
        radius: 9,
        link: Urls.musicStudio.keyboard.path,
    },
    {
        type: "arrow",
        yPosition: -55,
        zPosition: 80,
        xPosition: -15,
        xRotation: 270,
        yRotation: 0,
        zRotation: 270,
        radius: 7,
        link: Urls.musicStudio.recording.path,
    },
];

export const tshirtHotspots = [
    {
        type: "spot",
        yPosition: -30,
        zPosition: -45,
        xPosition: 5,
        xRotation: 270,
        yRotation: 0,
        zRotation: -360,
        radius: 5,
        link: Urls.musicStudio.piano.path,
    },
    {
        type: "spot",
        yPosition: -30,
        zPosition: -60,
        xPosition: 45,
        xRotation: 280,
        yRotation: -65,
        zRotation: 45,
        radius: 5,
        link: Urls.musicStudio.shelves.path,
    },
    {
        type: "spot",
        yPosition: -30,
        zPosition: 15,
        xPosition: 55,
        xRotation: 270,
        yRotation: 0,
        zRotation: 270,
        radius: 5,
        link: Urls.musicStudio.mac.path,
    },
    {
        type: "spot",
        yPosition: -30,
        zPosition: 55,
        xPosition: 55,
        xRotation: 270,
        yRotation: 0,
        zRotation: 225,
        radius: 5,
        link: Urls.musicStudio.keyboard.path,
    },
    {
        type: "arrow",
        yPosition: -30,
        zPosition: -46,
        xPosition: 87,
        xRotation: 270,
        yRotation: 0,
        zRotation: 30,
        radius: 8,
        link: Urls.musicStudio.recording.path,
    }
];

export const rooms = [
    {
        name: "Sound Booth",
        img: mac,
        route: Urls.musicStudio.mac,
        yRotation: 360,
    },
    {
        name: "Piano",
        img: piano,
        route: Urls.musicStudio.piano,
        yRotation: 90,
    },
    {
        name: "Recording Room",
        img: recording,
        route: Urls.musicStudio.recording,
        yRotation: 90,
    },
    {
        name: "Record Shelf",
        img: shelves,
        route: Urls.musicStudio.shelves,
        yRotation: 90,
    },
    {
        name: "T-shirts",
        img: tshirt,
        route: Urls.musicStudio.tshirt,
        yRotation: 90,
    },
    {
        name: "Keyboard",
        img: keyboard,
        route: Urls.musicStudio.keyboard,
        yRotation: 90,
    },

];